import { frontendURL } from 'dashboard/helper/URLHelper';
import {
  ROLES,
  CONVERSATION_PERMISSIONS,
} from 'dashboard/constants/permissions.js';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

// Lazy load components
const KanbanIndex = () => import('dashboard/views/kanban/Index.vue');
const KanbanSettings = () => import('dashboard/views/kanban/Settings.vue');
const FunnelList = () => import('dashboard/components/kanban/settings/FunnelList.vue');
const EditFunnel = () => import('dashboard/components/kanban/settings/EditFunnel.vue');

export const routes = [
  {
    path: frontendURL('accounts/:accountId/kanban'),
    name: 'kanban_funnels',
    component: KanbanIndex,
    meta: {
      permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
      featureFlag: FEATURE_FLAGS.KANBAN_VISIBILITY,
    },
  },
  {
    path: frontendURL('accounts/:accountId/kanban/funnel/:funnelId'),
    name: 'kanban_board',
    component: KanbanIndex,
    props: true,
    meta: {
      permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
      featureFlag: FEATURE_FLAGS.KANBAN_VISIBILITY,
    },
  },
  {
    path: frontendURL('accounts/:accountId/kanban/settings'),
    name: 'kanban_settings', 
    component: FunnelList,
    meta: {
      permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
      featureFlag: FEATURE_FLAGS.KANBAN_VISIBILITY,
    },
  },
  {
    path: frontendURL('accounts/:accountId/kanban/settings/funnel/:funnelId'),
    name: 'kanban_funnel_edit',
    component: EditFunnel,
    props: true,
    meta: {
      permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
      featureFlag: FEATURE_FLAGS.KANBAN_VISIBILITY,
    },
  },
];
